import React from 'react';
import PropTypes from 'prop-types';
import {
  FormHelperText,
  InputAdornment,
  TextField,
  Box,
  Container,
  IconButton,
} from '@material-ui/core';
import { useAppInputStyles } from './styles';
import SuccessIcon from '../icons/color/ic__exito.svg';
import InfoIcon from '../icons/color/ic__informacion.svg';
import ErrorIcon from '../icons/color/ic__error.svg';

const AppInput = ({ ...props }) => {
  const {
    issueFormName,
    disabled,
    name,
    error,
    value,
    type,
    label,
    required,
    rows,
    multiline,
    inputAdornment,
    success,
    helperText,
    errorMessage,
    onChange,
    onBlur,
    hidden,
    info,
    onClick,
    testId,
  } = props;

  const classes = useAppInputStyles({ hidden });
  const handleChange = (event) => {
    onChange(event);
  };

  const handleBlur = (event) => {
    onBlur && onBlur(event);
  };

  const handleClick = (event) => {
    onClick(event);
  };

  return (
    <Box className={classes.container}>
      <Container>
        <TextField
          data-testid={testId}
          data-cy={
            issueFormName ? `input${name}${issueFormName}` : `input${name}`
          }
          className={classes.input}
          onChange={handleChange}
          onBlur={handleBlur}
          size="small"
          variant="outlined"
          disabled={disabled}
          name={name}
          error={error}
          value={value}
          type={type}
          label={label}
          required={required}
          multiline={multiline}
          minRows={rows}
          InputProps={{
            startAdornment: inputAdornment && (
              <InputAdornment position="start">{inputAdornment}</InputAdornment>
            ),
            endAdornment: (
              <React.Fragment>
                {name === 'aurisTicketId' ? (
                  <InputAdornment position="end">
                    {value === ''
                      ? !success && (
                          <img
                            className={classes.image}
                            src={ErrorIcon}
                            alt="error icon"
                          />
                        )
                      : success &&
                        value?.length && (
                          <img
                            className={classes.image}
                            src={SuccessIcon}
                            alt="success icon"
                          />
                        )}{' '}
                  </InputAdornment>
                ) : (
                  value && (
                    <InputAdornment position="end">
                      {success && value?.length && (
                        <img
                          className={classes.image}
                          src={SuccessIcon}
                          alt="success icon"
                        />
                      )}{' '}
                    </InputAdornment>
                  )
                )}

                {info && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClick}
                      data-cy={`buttonIcon${name}`}
                      edge="end"
                    >
                      <img
                        src={InfoIcon}
                        className={classes.image}
                        alt="info icon"
                      />
                    </IconButton>
                  </InputAdornment>
                )}
              </React.Fragment>
            ),
          }}
        />
        {!error && helperText && (
          <FormHelperText className={classes.helperText}>
            {helperText}
          </FormHelperText>
        )}
        {error && (
          <FormHelperText className={classes.errorText}>
            {errorMessage}
          </FormHelperText>
        )}
      </Container>
    </Box>
  );
};

AppInput.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputAdornment: PropTypes.string,
  success: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.string,
  errorMessage: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  hidden: PropTypes.bool,
  issueFormName: PropTypes.string,
  info: PropTypes.bool,
  onClick: PropTypes.func,
  testId: PropTypes.string,
};

export default AppInput;
